import {
  subDays, startOfDay, startOfQuarter, subQuarters, startOfYear, subYears,
  differenceInDays, addDays, differenceInYears,
} from 'date-fns';
import type { RangePreset } from './metrics';

export interface DateRange { from: Date; to: Date; }

export function resolvePresetRange(
  preset: RangePreset,
  opts: { now?: Date; from?: Date; to?: Date } = {},
): DateRange {
  const now = opts.now ?? new Date();
  switch (preset) {
    case 'today': return { from: startOfDay(now), to: now };
    case '7d':    return { from: subDays(now, 7),  to: now };
    case '30d':   return { from: subDays(now, 30), to: now };
    case '90d':   return { from: subDays(now, 90), to: now };
    case 'qtd':   return { from: startOfQuarter(now), to: now };
    case 'ytd':   return { from: startOfYear(now),    to: now };
    case 'custom':
      if (!opts.from || !opts.to) throw new Error('custom range requires from + to');
      return { from: opts.from, to: opts.to };
  }
}

export function resolveCompareRange(preset: RangePreset, current: DateRange): DateRange | null {
  if (preset === 'custom' && (!current.from || !current.to)) return null;

  const lengthDays = differenceInDays(current.to, current.from);
  const lengthYears = differenceInYears(current.to, current.from);

  if (preset === 'custom' && (lengthDays < 3 || lengthYears > 2)) return null;

  switch (preset) {
    case 'today':
      return { from: subDays(current.from, 1), to: subDays(current.to, 1) };
    case '7d':
    case '30d':
    case '90d':
    case 'custom': {
      return { from: subDays(current.from, lengthDays), to: current.from };
    }
    case 'qtd': {
      const elapsed = differenceInDays(current.to, current.from);
      const prevQStart = startOfQuarter(subQuarters(current.from, 1));
      return { from: prevQStart, to: addDays(prevQStart, elapsed) };
    }
    case 'ytd': {
      return { from: subYears(current.from, 1), to: subYears(current.to, 1) };
    }
  }
}
